import api from '../middleware/api'
import { actions } from 'redux-clerk2'
import * as notificationActions from './notifications'



const mainActions = actions({
  actionPrefix: 'USERS',
  uidField: 'id',
  actionSettings:{
	  default:{
		  url: `users`
		  ,error: {
			  type: 'notification',
			  title: 'Oops! Something went wrong',
		      //message: 'Brace yourself till we get the error fixed. You may also refresh the page or try again later',
		      kind: 'error'
		  }
		//   ,notification: {
		// 	  //type: 'notification',
		// 	  title: 'Successfully saved!',
		//       //message: error.response.data.message,
		//       kind: 'success'
		//   }
		//   ,loading: 'Please wait while we are doing some work...'
	  }
  },
  api: api,
  notificationActions: notificationActions
})

export function initDashboard( instance, {startDate, endDate, representative_id, role, userFieldOverwrite, entity_id}) {
	//console.log('startDate', startDate);
	//console.log('endDate', endDate);
	//console.log(`params:`, params)
	const userRole = role?role:'';
	const userField = userFieldOverwrite?userFieldOverwrite:'';
	const entityId = entity_id?entity_id:'';
	return {
        //type: 'RATE_INVENTORY',
        types: ['DASHBOARD_FETCH', 'DASHBOARD_SUCCESS', 'DASHBOARD_FAILURE'],
		payload: {
			request:{
				method: 'GET',
				url:`dashboard?start_date=`+startDate+`&end_date=`+endDate+`&role=`+userRole+`&user_field_overwrite=`+userField+`&entity_id=`+entityId,
				// data: params
            },
            options: {
                onSuccess({ getState, dispatch, response }) {
                    // console.log(`response:`, response.data);

                    if(response.data && response.data.data && response.data.data.reservations){
                        dispatch({ type: 'RESERVATIONS_FETCH_SUCCESS', instance: instance, uidField: 'id', responseData: response.data.data.reservations, options: { appendResponse: false } });
					}

					if(response.data && response.data.data && response.data.data.beauty_advisors ){
                        dispatch({ type: 'BEAUTY_ADVISORS_FETCH_SUCCESS', instance: instance, uidField: 'id', responseData: response.data.data.beauty_advisors, options: { appendResponse: false } });
					}

					if(response.data && response.data.data && response.data.data.representatives){
                        dispatch({ type: 'REPRESENTATIVES_FETCH_SUCCESS', instance: instance, uidField: 'id', responseData: response.data.data.representatives, options: { appendResponse: false } });
					}

					if(response.data && response.data.data && response.data.data.trainers){
                        dispatch({ type: 'TRAINERS_FETCH_SUCCESS', instance: instance, uidField: 'id', responseData: response.data.data.trainers, options: { appendResponse: false } });
					}

					if(response.data && response.data.data && response.data.data.pharmacies){
                        dispatch({ type: 'PHARMACIES_FETCH_SUCCESS', instance: instance, uidField: 'id', responseData: response.data.data.pharmacies, options: { appendResponse: false } });
					}

					if(response.data && response.data.data && response.data.data.leaves_of_absense){
                        dispatch({ type: 'LEAVES_OF_ABSENSE_FETCH_SUCCESS', instance: instance, uidField: 'id', responseData: response.data.data.leaves_of_absense, options: { appendResponse: false } });
					}

                    return { ...(response.data && response.data.data) || {} };
                },
                onError({ getState, dispatch, error }) {
					//dispatch({ type: 'INVENTORY_SEASONS_YIELDING_FAILURE', instance: instance, payload: error.response });
                }
            }
        }
	}
}


export function dashboardCalendar( instance, {region_id, reservation_id, beauty_advisor_id, status, pharmacy_id, representative_id, calendar_from, calendar_to, ignored_statuses,pharmacy_types, book_from, book_to, subregion_id, commitment, type, overquota_check, region_commitment, program_types}) {
	//console.log('startDate', startDate);
	//console.log('endDate', endDate);
	//console.log(`params:`, params)
	
	return {
        //type: 'RATE_INVENTORY',
        types: ['DASHBOARD_CALENDAR_FETCH', 'DASHBOARD_CALENDAR_SUCCESS', 'DASHBOARD_CALENDAR_FAILURE'],
		payload: {
			request:{
				method: 'GET',
				url:`dashboardCalendar?reservation_id=`+reservation_id+`&beauty_advisor_id=`+beauty_advisor_id+`&status=`+status+`&commitment=`+commitment+`&pharmacy_id=`+pharmacy_id+`&representative_id=`+representative_id+`&calendar_from=`+calendar_from+`&calendar_to=`+calendar_to+`&ignored_statuses=`+ignored_statuses+`&pharmacy_types=`+pharmacy_types+`&book_from=`+book_from+`&book_to=`+book_to+`&type=`+type+`&region_id=`+region_id+`&subregion_id=`+subregion_id+`&overquota_check=`+overquota_check+`&region_commitment=`+region_commitment+`&program_types=`+program_types,
				// data: params
            },
            options: {
                onSuccess({ getState, dispatch, response }) {
                    // console.log(`response:`, response.data);

                    if(response.data && response.data.data && response.data.data.reservations){
                        dispatch({ type: 'RESERVATIONS_FETCH_SUCCESS', instance: instance, uidField: 'id', responseData: response.data.data.reservations, options: { appendResponse: false } });
					}

					if(response.data && response.data.data && response.data.data.holidays ){
                        dispatch({ type: 'HOLIDAYS_FETCH_SUCCESS', instance: instance, uidField: 'id', responseData: response.data.data.holidays, options: { appendResponse: true } });
					}

					
					if(response.data && response.data.data && response.data.data.leaves_of_absense){
                        dispatch({ type: 'LEAVES_OF_ABSENSE_FETCH_SUCCESS', instance: instance, uidField: 'id', responseData: response.data.data.leaves_of_absense, options: { appendResponse: false } });
					}

					if(response.data && response.data.data && response.data.data.availabilities){
                        dispatch({ type: 'AVAILABILITIES_FETCH_SUCCESS', instance: instance, uidField: 'id', responseData: response.data.data.availabilities, options: { appendResponse: false }});
					}

                    return { ...(response.data && response.data.data) || {} };
                },
                onError({ getState, dispatch, error }) {
					//dispatch({ type: 'INVENTORY_SEASONS_YIELDING_FAILURE', instance: instance, payload: error.response });
                }
            }
        }
	}
}

export function trainingCalendar( instance, {calendar_from, calendar_to}) {

	//console.log('startDate', startDate);
	//console.log('endDate', endDate);
	//console.log(`params:`, params)
	
	return {
        //type: 'RATE_INVENTORY',
        types: ['TRAINING_CALENDAR_FETCH', 'TRAINING_CALENDAR_SUCCESS', 'TRAINING_CALENDAR_FAILURE'],
		payload: {
			request:{
				method: 'GET',
				url:`trainerAvailabilities?calendar_from=`+calendar_from+`&calendar_to=`+calendar_to
				// data: params
            },
            options: {
                onSuccess({ getState, dispatch, response }) {
                    // console.log(`response:`, response.data);

					if(response.data && response.data.data && response.data.data.trainer_availabilities){
                        dispatch({ type: 'TRAINER_AVAILABILITIES_FETCH_SUCCESS', instance: instance, uidField: 'id', responseData: response.data.data.trainer_availabilities, options: { appendResponse: false }});
					}

                    return { ...(response.data && response.data.data) || {} };
                },
                onError({ getState, dispatch, error }) {
					//dispatch({ type: 'INVENTORY_SEASONS_YIELDING_FAILURE', instance: instance, payload: error.response });
                }
            }
        }
	}
}





export default mainActions